import { USERLANE_ID } from '@/common/config'
import { logger } from '@/services/logger/loggers'

type Response = {
  entryPoint: string
  integrity: string
}

// They don't provide any SDK 🤷
declare global {
  interface Window {
    Userlane: {
      (command: 'init', projectId: string): Promise<void>
      (
        command: 'identify',
        userId: string,
        attributes: {
          roles: string[]
        }
      ): Promise<void>
    }
  }
}

export const startUserlane = async (userId: string, roles: string[]) => {
  if (!USERLANE_ID) {
    logger.error('[tms - Userlane]: USERLANE_ID is not defined', {})
    return
  }

  try {
    const scriptUrl = await fetch(
      'https://api.userlane.com/integrity/artifacts/main'
    )

    const response = (await scriptUrl.json()) as Response
    const scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = `https://secure.userlane.com/${response.entryPoint}`
      script.integrity = response.integrity
      script.crossOrigin = 'anonymous'
      script.async = true
      script.onerror = () => {
        reject(new Error('Failed to load Userlane script'))
      }
      script.onload = () => {
        resolve(0)
      }

      document.head.appendChild(script)
    })

    await scriptPromise
    await window.Userlane('identify', userId, {
      roles,
    })

    await window.Userlane('init', USERLANE_ID)
  } catch (e) {
    logger.error('Failed to userlane', { error: e })
  }
}
